module.exports = __webpack_public_path__ + "static/media/focus-bg.eddca30f.png";